import { createContext, useContext } from 'react';

export const StaffPanelContext = createContext({ inPanel: false, userData: null });

export function useStaffPanel() {
    return useContext(StaffPanelContext);
}

export function useInStaffPanel() {
    return useContext(StaffPanelContext).inPanel;
}
